/**
 * 本人設定（オペレーター向け）。いまはパスキーの Card だけを置く。
 *
 * 設計: docs/design/2026-09-23-passkey-authentication.md 9 節（15 節 Q6）
 *
 * オペレーター本人の資格情報も、顧客向けと同じ表・同じ Mutation で扱う。
 * Card は顧客向けの「ログイン・権限」と**同じ部品**（共通パッケージの
 * `PasskeysPanel`）で、画面を別に作らない。将来の本人設定はここへ集める。
 *
 * オペレーターのトークンは代行の文脈を持たない（代行はオペレーターが顧客向けの
 * 面へ入るもので、この面には来ない）が、判断は画面ではなく viewer の値に任せる。
 */

import { PageHeader, PasskeysPanel } from "visumo-data-agent-web-shared";

import { HelpIcon } from "../help/index";
import { useViewer } from "../ViewerContext";

export function AccountPage() {
  const viewer = useViewer();
  return (
    <div className="vd-stack">
      <PageHeader
        title="本人設定"
        description="あなた自身のログインの設定です。どの会社を開いていても同じものが使われます。"
        titleExtra={<HelpIcon slug="account/passkeys" />}
      />
      <PasskeysPanel
        delegated={viewer.delegation != null}
        help={<HelpIcon slug="account/passkeys" />}
      />
    </div>
  );
}
